import { render, staticRenderFns } from "./menu-slider.vue?vue&type=template&id=d8e4a7ce&"
import script from "./menu-slider.vue?vue&type=script&lang=js&"
export * from "./menu-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports